module.exports = __webpack_public_path__ + "img/new_index_cooperate_bg2.b0cdf84c.png";